// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import type { VMessageTemplateContext } from '../../index.ts';

import { AssertError } from '@atlassian/vindicated';
export function assert(value: any): VMessageTemplateContext {
    const result = validate(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new AssertError('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data as VMessageTemplateContext;
}
export { assert as assertMessageTemplateContext };


export function is(value: any): value is VMessageTemplateContext {
	const result = validate(value);
    return result.success;
}
export { is as isMessageTemplateContext };


import type { ValidationResult } from '@atlassian/vindicated';
export function validate(value: any): ValidationResult<VMessageTemplateContext> {
    const errors = [];
    const originalData = value;
    
	if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        errors.push({ path: 'value', expected: 'MessageTemplateContext', value: value });
    } else {
			if (!('cloudId' in value)) {
				errors.push({ path: 'value["cloudId"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["cloudId"] !== 'string') errors.push({ path: 'value["cloudId"]', expected: 'string', value: value["cloudId"] });
			}
			if (!('triggerType' in value)) {
				errors.push({ path: 'value["triggerType"]', expected: '"onPageLoad" | "gasV3" | "poTrigger" | "subscription"', value: undefined });
			} else {
				
    {
        let value__triggerType___valid = false;
        
        if (!value__triggerType___valid) {
            const value__triggerType___errors_0 = [];
            if (value["triggerType"] !== "onPageLoad") value__triggerType___errors_0.push({ path: 'value["triggerType"]', expected: "onPageLoad", value: value["triggerType"] });
            if (value__triggerType___errors_0.length === 0) {
                value__triggerType___valid = true;
            }
        }

        if (!value__triggerType___valid) {
            const value__triggerType___errors_1 = [];
            if (value["triggerType"] !== "gasV3") value__triggerType___errors_1.push({ path: 'value["triggerType"]', expected: "gasV3", value: value["triggerType"] });
            if (value__triggerType___errors_1.length === 0) {
                value__triggerType___valid = true;
            }
        }

        if (!value__triggerType___valid) {
            const value__triggerType___errors_2 = [];
            if (value["triggerType"] !== "poTrigger") value__triggerType___errors_2.push({ path: 'value["triggerType"]', expected: "poTrigger", value: value["triggerType"] });
            if (value__triggerType___errors_2.length === 0) {
                value__triggerType___valid = true;
            }
        }

        if (!value__triggerType___valid) {
            const value__triggerType___errors_3 = [];
            if (value["triggerType"] !== "subscription") value__triggerType___errors_3.push({ path: 'value["triggerType"]', expected: "subscription", value: value["triggerType"] });
            if (value__triggerType___errors_3.length === 0) {
                value__triggerType___valid = true;
            }
        }
        if (!value__triggerType___valid) {
            errors.push({ path: 'value["triggerType"]', expected: '"onPageLoad" | "gasV3" | "poTrigger" | "subscription"', value: value["triggerType"] });
        }
    }
			}
    }
    if (errors.length === 0) return { success: true, data: value };
    return { success: false, data: originalData, errors: errors };
}
export { validate as validateMessageTemplateContext };
